import React from 'react'

import { Rule } from '../RuleBox'

const initialSaleRules: Array<Rule> = [
  {
    details:
      'When a geotoken is minted, there is a 10% minting reward that is removed from the minting deposit before anything else.  This is rewarded to the minter of the geotoken.  During the first 24 hours after the close of an auction, only the winning bidder can receive this reward.  After the first 24 hours after the close of the auction, whomever mints it receives the reward.',
    reason:
      'To address the high ETH gas prices for minting XYO geotokens, there is a reward for the minter of the new geotoken.  We chose to allow a 24 hour period for the winner of the auction to receive this reward to optimize the gas price for minting it.  We decided to allow others to receive it after the first 24 hours to prevent geotokens from going unminted.',
    summary: '10% minting reward (XYO World 2.0 Update)',
  },
  {
    details:
      'All XYO World Geotokens act as containers of value and data.  When a geotoken is minted, 75% of the minting deposit is stored in the geotoken and can be retrieved once the geotoken is unlocked.',
    reason:
      'Finding a balance between returning a portion of the minting deposit to the minter and not allowing people to constantly reuse tokens for minting led to the decision to have a lock up period.  This also is a natural start to a staking system that can be required by applications that render based on XYO World geotokens.',
    summary: '75% of remaining minting deposit goes into geotoken',
  },
  {
    details: (
      <div>
        <p>We call this&quot;Token Flow&quot;</p>
        <ul>
          <li>16% - 1 Level Up (If Exists)</li>
          <li>4% - 2 Levels Up (If Exists)</li>
          <li>1% - 3 Levels Up (If Exists)</li>
          <li>0.25% - 4 Levels Up (If Exists)</li>
        </ul>
      </div>
    ),
    reason:
      'When a child geotoken is sold, the parent getoken naturally loses value by losing full authority of the space that is contained in the geotoken.  Since this is not optional, it is natural that the parent geotoken is compensated for this loss.',
    summary: '21.25% of remaining minting deposit goes to parent geotoken (if they exist)',
  },
  {
    details: '3.75%-9% of every sale price will be burned.',
    reason:
      'In the case where there are not any parents to receive the tokens, the tokens are burned. We feel that reducing the supply in this way allows for a natural increase in the value of the XYO token.',
    summary: 'Remaining XYO tokens are burned',
  },
  {
    details: 'As soon as a geotoken sale is completed, the child geotokens become available for sale.',
    reason:
      'Since the reasonable depth of sale in different parts of the world is hard to predict, we elected to start auctions as a tree, with the leaves always being available. This allows for a constantly available supply of geotokens, while maintaining the value and authority for the parent geotokens.',
    summary: 'Sale of child geotokens start when parent sale is complete',
  },
]

export default initialSaleRules
